module.exports = __webpack_public_path__ + "img/icon-warning-polartlavtrykk-2.ae2392d5.svg";